import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import FunctionalButton from '../../components/Buttons/FunctionalButton';
import SearchForm from '../../components/SearchForm';
import ProductItem from '../../components/Products/Item';

@inject('AuthStore', 'ProductStore', 'StoreStore')
@observer
class Products extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        if (Helpers.objectToArray(this.props.ProductStore.products.content).length === 0) {
            Helpers.getProducts();
        }
    }

    render() {
        const products = this.props.ProductStore.searchFilterText !== "" ?
            Helpers.objectToArray(this.props.ProductStore.searchProducts.content).reverse()
            :
            Helpers.objectToArray(this.props.ProductStore.products.content).reverse();

        const storeId: any = localStorage.getItem('storeId');
        const storeData = this.props.StoreStore.stores[storeId];

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('products')}
                >
                    <section id="shop">
                        <section id="breadcrumbs" className="pt-6 bg-gray-50">
                            <div className="container mx-auto px-4 text-xs md:text-base">
                                <ol className="list-reset flex">
                                    <li>
                                        <Link
                                            className="font-semibold hover:text-primary"
                                            to={`/home`}
                                        >
                                            {Helpers.translation('home')}
                                        </Link>
                                    </li>
                                    <li>
                                        <span className="mx-2">&gt;</span>
                                    </li>
                                    <li>{Helpers.translation('shop')}</li>
                                </ol>
                            </div>
                        </section>

                        <div className="container mx-auto p-4">
                            <div className="flex flex-col">
                                <SearchForm
                                    inputs={[
                                        {
                                            type: "text",
                                            name: "title",
                                            placeholder: Helpers.translation('product_name'),
                                        },
                                        {
                                            type: "selectMulti",
                                            options: Helpers.getProductCategorySelectBoxValues(),
                                            findColumn: "id",
                                            name: "product_categories",
                                            placeholder: Helpers.translation('product_categories')
                                        },
                                    ]}
                                    sendFunction={Helpers.searchProducts}
                                    store={this.props.ProductStore}
                                    inFilters={[
                                        `filters[stores][changeIndex]=${storeId}`,
                                        `filters[visible][changeIndex]=true`,
                                    ]}
                                    autoSend={true}
                                />

                                {/* Products List */}
                                <div className="w-full mt-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2">
                                        {
                                            products.map((product: any, index: number) => {
                                                const convertCurrencyData = Helpers.convertCurrencyData(product.currency);
                                                const mainImage: any = product.main_image.data !== null ? Helpers.getMediumImageUrl(product.main_image.data.attributes) : null;
                                                const category = product.product_categories.data.map((categoryData: any) => {
                                                    return categoryData.attributes.title;
                                                }).join(" - ");

                                                let price = null;
                                                if (Helpers.getUserData().isLogin) {
                                                    price = convertCurrencyData !== null ? Helpers.returnPrice(product.id, {
                                                        price: product.price,
                                                        ...convertCurrencyData
                                                    }) : null;
                                                } else {
                                                    if (storeData.not_login_view_price !== "not_view") {
                                                        let productPrice = null;

                                                        if (storeData.not_login_view_price === "customer_price") {
                                                            productPrice = product.customer_price;
                                                        }

                                                        if (storeData.not_login_view_price === "dealer_price") {
                                                            productPrice = product.price;
                                                        }

                                                        price = convertCurrencyData !== null ? Helpers.returnPrice(product.id, {
                                                            price: productPrice,
                                                            ...convertCurrencyData
                                                        }) : null;
                                                    }
                                                }

                                                return (
                                                    <ProductItem
                                                        key={index}
                                                        title={product.title}
                                                        id={product.id}
                                                        mainImage={mainImage}
                                                        category={category}
                                                        priceData={price}
                                                    />
                                                )
                                            })
                                        }
                                    </div>

                                    {
                                        this.props.ProductStore.searchFilterText !== "" ?
                                            (Helpers.objectToArray(this.props.ProductStore.searchProducts.content).length >= 1 && this.props.ProductStore.searchProducts.page <= this.props.ProductStore.searchProducts.pageCount) &&
                                            <div className="w-full flex flex-row justify-center items-center mt-4">
                                                <FunctionalButton
                                                    onPress={() => Helpers.searchProducts()}
                                                    text={Helpers.translation('show-more')}
                                                    fullWidth={false}
                                                    rounded
                                                />
                                            </div>
                                            :
                                            (Helpers.objectToArray(this.props.ProductStore.products.content).length >= 1 && this.props.ProductStore.products.page <= this.props.ProductStore.products.pageCount) &&
                                            <div className="w-full flex flex-row justify-center items-center mt-4">
                                                <FunctionalButton
                                                    onPress={() => Helpers.getProducts()}
                                                    text={Helpers.translation('show-more')}
                                                    fullWidth={false}
                                                    rounded
                                                />
                                            </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <Products {...props} navigate={navigate} />
}

export default WithNavigate;